// Externe Bibliotheken
import React, { Component } from 'react';

// Interne Module
import { affiliate_checkIsAllowToBookService, checkTripEnded } from '@/_helper/checkAccess';
import * as storage from '@/_helper/storage';

// Komponenten
import Header from '@/comp/header/header';
import Footer from '@/comp/footer/Footer';
import StatusPage from '@/comp/statusPage/statusPage';
import { StepProgressBar } from '@/comp/stepProgressBar/StepProgressBar';
import ClaimForm from './components/claimForm/claimForm';
import ClaimUploadForm from './components/claimUploadForm/claimUploadForm';
import ClaimContactForm from './components/claimContactForm/claimContactForm';
import ClaimReviewForm from './components/claimReviewForm/claimReviewForm';

// Styles
import './claim.scss';
import { AppContext } from '@/context/AppContext.tsx';

export const iconMapping = {
    Accommodation: 'bed300',
    Documents: 'accountCircle',
    InboundFlight: 'flight300',
    Luggage: 'luggage300',
    Others: 'syncProblem300',
    PersonalData: 'description',
    OutboundFlight: 'flight300',
    InboundTransfer: 'airportShuttle300',
    OutboundTransfer: 'airportShuttle300',
};

class Index extends Component {
    state = {
        submitSuccess: false,
    };

    static contextType = AppContext;

    #bookingData = { data: { allowClaim: false } };
    #claimEnabled = window.$claimEnabled;
    #contactDataMail = storage.get('bookingData')?.data?.pbeCustomerEmail;
    #tripEnded = false;
    #backLink = '';

    constructor(props) {
        super(props);

        this.#bookingData = storage.get('bookingData') ?? this.#bookingData;
        document.title = 'Reklamation' + window.$documentTitle;
    }

    componentDidMount() {
        this.#tripEnded = checkTripEnded();
        const { bookingData } = this.context;
        const { allowedInteractions } = bookingData?.data;

        if (
            this.#claimEnabled === 'false' ||
            !allowedInteractions?.claim.claimAllowed ||
            allowedInteractions?.claim.claimSent ||
            !affiliate_checkIsAllowToBookService('claim')
        ) {
            if (window.$affiliate === 'ch24') {
                if (
                    this.#bookingData.data.pbeHash !== null &&
                    this.#bookingData.data.pbeHash !== undefined &&
                    this.#bookingData.data.pbeHash !== ''
                ) {
                    let backURL =
                        new URL(this.#bookingData.data.pbeHash).origin +
                        new URL(this.#bookingData.data.pbeHash).pathname;
                    this.#backLink = backURL;
                } else {
                    this.#backLink = 'https://kundenbereich.check24.de/';
                }
            }

            window.location.href = this.#backLink;
            return false;
        } else {
            if (window.$affiliate === 'ch24') {
                this.setContactData({ email: this.#bookingData.data.pbeCustomerEmail });

                if (storage.get('mode') !== null && storage.get('mode') === 'app') {
                    let head = document.getElementsByTagName('head').item(0);
                    let script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.async = true;
                    script.src = './libs/c24app.js';
                    head.appendChild(script);
                }
            }

            this.setState({
                currentStep: 0,
            });
        }
    }

    setCurrentStep = (n) => {
        if (n >= 0 && n <= 4) {
            this.setState({
                currentStep: n,
            });
        }
    };

    escapeString = (str) => {
        return str.replaceAll(' ', '-').replace(/[()/]/g, '');
    };

    setDataReturnTree = (props) => {
        this.setState({
            dataReturnTree: props,
        });
    };

    setUploadElements = (props) => {
        this.setState({
            uploadElements: props,
        });
    };

    setFileList = (props) => {
        this.setState({
            fileList: props,
        });
    };

    removeFromFileList = (props) => {
        if (this.state.fileList && this.state.fileList[props]) {
            this.setState((state) => {
                delete state.fileList[props];
                return state;
            });
        }
    };

    setContactData = (props) => {
        this.setState({
            contactData: props,
        });
    };

    setFormState = (state) => {
        this.setState({
            formState: state,
        });
    };

    setDataTree = (props) => {
        this.setState({
            dataTree: props,
        });
    };

    setSubmitSuccess = (state) => {
        this.setState({
            submitSuccess: state,
        });
    };

    render() {
        const claimSteps =
            window.$affiliate === 'ch24' && typeof this.#contactDataMail === 'string'
                ? [
                      { label: 'Formular ausfüllen', index: 0 },
                      { label: 'Nachweise hochladen', index: 1 },
                      { label: 'Formular abschicken', index: 2 },
                  ]
                : [
                      { label: 'Formular ausfüllen', index: 0 },
                      { label: 'Nachweise hochladen', index: 1 },
                      { label: 'Kontaktdaten angeben', index: 2 },
                      { label: 'Formular abschicken', index: 3 },
                  ];
        window.scrollTo(0, 0);

        if (this.#tripEnded && this.state.currentStep >= 0 && this.state.currentStep < 5) {
            return (
                <>
                    <Header />
                    <div className="page-claim">
                        {this.state.currentStep < 4 && (
                            <StepProgressBar
                                currentStep={this.state.currentStep}
                                setCurrentStep={this.setCurrentStep}
                                steps={claimSteps}
                            />
                        )}
                        {this.state.currentStep === 0 && (
                            <ClaimForm
                                changeStep={this.setCurrentStep}
                                setUploadElements={this.setUploadElements}
                                setDataReturnTree={this.setDataReturnTree}
                                setDataTree={this.setDataTree}
                                saveState={this.setFormState}
                                initialState={this.state.formState}
                                removeFromFileList={this.removeFromFileList}
                                escapeString={this.escapeString}
                            />
                        )}
                        {this.state.currentStep === 1 && (
                            <ClaimUploadForm
                                changeStep={this.setCurrentStep}
                                contactData={this.state.contactData}
                                setFileList={this.setFileList}
                                fileList={this.state.fileList}
                                uploadElements={this.state.uploadElements}
                                dataReturnTree={this.state.dataReturnTree}
                                dataTree={this.state.dataTree}
                                escapeString={this.escapeString}
                            />
                        )}
                        {this.state.currentStep === 2 &&
                            (!window.$affiliate ||
                                (window.$affiliate === 'ch24' && typeof this.#contactDataMail !== 'string')) && (
                                <ClaimContactForm
                                    changeStep={this.setCurrentStep}
                                    setContactData={this.setContactData}
                                    contactData={this.state.contactData}
                                />
                            )}
                        {this.state.currentStep === 3 && (
                            <ClaimReviewForm
                                dataReturnTree={this.state.dataReturnTree}
                                dataTree={this.state.dataTree}
                                contactData={this.state.contactData}
                                files={this.state.fileList}
                                changeStep={this.setCurrentStep}
                                setSendForm={this.setSubmitSuccess}
                                escapeString={this.escapeString}
                            />
                        )}
                        {this.state.currentStep === 4 && (
                            <StatusPage type={this.state.submitSuccess ? 'success' : 'error'} subPage="claim" />
                        )}
                    </div>
                    <Footer />
                </>
            );
        } else {
            return (
                <>
                    <Header />
                    <div className="page-claim">
                        <StatusPage type={this.#tripEnded ? 'error' : 'warning'} subPage="claim" />
                    </div>
                    <Footer />
                </>
            );
        }
    }
}

export default Index;
